module.exports = __webpack_public_path__ + "static/tfuandr-48f57090b7abd6e34445c1a21e122eff.jpg";